import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { catchError, of, switchMap, tap } from 'rxjs';
import { RoomDef, ScheduleRow } from '../../models/video.model';
import {NativeServiceApiProvider} from "../../../services/native-api-provider.service";

@Component({
    selector: 'app-schedule-details-page',
    templateUrl: './schedule-details-page.component.html',
    styleUrls: ['./schedule-details-page.component.scss'],
    standalone: false
})
export class ScheduleDetailsPageComponent implements OnInit {

  studentId: number;
  schoolId: number;
  scheduleId: number;
  schedule: ScheduleRow
  room: RoomDef

  constructor(private route: ActivatedRoute,
    private provider: NativeServiceApiProvider) { }

  ngOnInit(): void {
    this.route.paramMap.pipe(
      tap(params => {
        this.studentId = +params.get('studentId')
        this.schoolId = +params.get('schoolId')
        this.scheduleId = +params.get('scheduleId')
      }),
      switchMap( _ => this.provider.video()),
      switchMap(api => api.getStudentScheduleDetails(
        this.schoolId, this.studentId, this.scheduleId).pipe(
          catchError(_ => of<ScheduleRow>(null))
        )
      )
    ).subscribe(schedule => {
      this.schedule = schedule
      this.room = schedule?.room
    })
  }

  getScheduleDatePlanned() {
    const startDate = this.schedule?.schedule?.details?.startDate
    if (startDate == null)
      return ''
    return new Date(startDate)
      .toLocaleString('en-uk',
        { day: '2-digit', month: 'short', year: 'numeric',
          hour: 'numeric', minute: 'numeric' })
  }

  getScheduleName() {
    return this.room?.name
  }
}
